/**
 * Demo data for Ghost Supply ROI Dashboard (CFO View).
 */

export interface GhostSupplyEntry {
  id: string;
  procedureName: string;
  cptCode: string;
  totalCases: number;
  wasteItems: number;
  adhocItems: number;
  matchRate: number;
  estimatedWasteCost: number;
  nursingMinutesSaved: number;
}

export interface MonthlyLeakage {
  month: string;
  leakagePrevented: number;
  nursingHoursRecovered: number;
}

export const GHOST_SUPPLY_PROCEDURES: GhostSupplyEntry[] = [
  {
    id: 'gs-1',
    procedureName: 'Total Hip Arthroplasty',
    cptCode: '27130',
    totalCases: 42,
    wasteItems: 68,
    adhocItems: 23,
    matchRate: 78,
    estimatedWasteCost: 14280,
    nursingMinutesSaved: 168,
  },
  {
    id: 'gs-2',
    procedureName: 'Total Knee Arthroplasty',
    cptCode: '27447',
    totalCases: 56,
    wasteItems: 89,
    adhocItems: 31,
    matchRate: 74,
    estimatedWasteCost: 18760,
    nursingMinutesSaved: 224,
  },
  {
    id: 'gs-3',
    procedureName: 'Shoulder Arthroscopy',
    cptCode: '29827',
    totalCases: 38,
    wasteItems: 42,
    adhocItems: 18,
    matchRate: 82,
    estimatedWasteCost: 8820,
    nursingMinutesSaved: 114,
  },
  {
    id: 'gs-4',
    procedureName: 'Carpal Tunnel Release',
    cptCode: '64721',
    totalCases: 64,
    wasteItems: 96,
    adhocItems: 8,
    matchRate: 88,
    estimatedWasteCost: 6720,
    nursingMinutesSaved: 256,
  },
  {
    id: 'gs-5',
    procedureName: 'ACL Reconstruction',
    cptCode: '29888',
    totalCases: 28,
    wasteItems: 56,
    adhocItems: 14,
    matchRate: 71,
    estimatedWasteCost: 15680,
    nursingMinutesSaved: 112,
  },
  {
    id: 'gs-6',
    procedureName: 'Rotator Cuff Repair',
    cptCode: '23412',
    totalCases: 33,
    wasteItems: 36,
    adhocItems: 12,
    matchRate: 84,
    estimatedWasteCost: 7560,
    nursingMinutesSaved: 99,
  },
  {
    id: 'gs-7',
    procedureName: 'Lumbar Decompression',
    cptCode: '63047',
    totalCases: 22,
    wasteItems: 28,
    adhocItems: 9,
    matchRate: 80,
    estimatedWasteCost: 9240,
    nursingMinutesSaved: 66,
  },
];

export const MONTHLY_LEAKAGE_DATA: MonthlyLeakage[] = [
  { month: 'Sep', leakagePrevented: 8420, nursingHoursRecovered: 18.2 },
  { month: 'Oct', leakagePrevented: 11680, nursingHoursRecovered: 24.5 },
  { month: 'Nov', leakagePrevented: 14350, nursingHoursRecovered: 28.1 },
  { month: 'Dec', leakagePrevented: 12890, nursingHoursRecovered: 22.8 },
  { month: 'Jan', leakagePrevented: 16720, nursingHoursRecovered: 31.4 },
  { month: 'Feb', leakagePrevented: 17000, nursingHoursRecovered: 32.0 },
];

export function getAggregateStats() {
  const sorted = [...GHOST_SUPPLY_PROCEDURES].sort((a, b) => b.estimatedWasteCost - a.estimatedWasteCost);
  const topOffenders = sorted.slice(0, 5);
  const totalWasteCost = GHOST_SUPPLY_PROCEDURES.reduce((s, p) => s + p.estimatedWasteCost, 0);
  const totalNursingMinutes = GHOST_SUPPLY_PROCEDURES.reduce((s, p) => s + p.nursingMinutesSaved, 0);
  const totalWasteItems = GHOST_SUPPLY_PROCEDURES.reduce((s, p) => s + p.wasteItems, 0);
  const totalCases = GHOST_SUPPLY_PROCEDURES.reduce((s, p) => s + p.totalCases, 0);
  const avgMatchRate = Math.round(GHOST_SUPPLY_PROCEDURES.reduce((s, p) => s + p.matchRate, 0) / GHOST_SUPPLY_PROCEDURES.length);

  return { topOffenders, totalWasteCost, totalNursingMinutes, totalWasteItems, totalCases, avgMatchRate };
}
